let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1wY11")).then(() => parcelRequire('b8Vr3'));